import { render, staticRenderFns } from "./MarcioAlmeida.vue?vue&type=template&id=08641204"
import script from "./MarcioAlmeida.vue?vue&type=script&lang=js"
export * from "./MarcioAlmeida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports